export interface TabDef {
    id: string;
    title: string;
    body: string[];
    projectId?: string;
    hidden?: boolean;
    curiosityLocked?: boolean;
}

export const TABS: TabDef[] = [
    {
        id: "t-rag",
        title: "How does RAG actually work?",
        body: [
            "short answer: it retrieves before it speaks.",
            "long answer: i built one so i'd stop just nodding along. it rewrites your query, searches a vector store, and answers with citations attached.",
        ],
        projectId: "rag-chatbot",
    },
    {
        id: "t-automate",
        title: "Can I automate this?",
        body: [
            "you asked this about a pricing document once. it escalated.",
            "the result is an AI workflow that reads technical pricing documents and hands back structured data.",
        ],
        projectId: "doc-processing",
    },
    {
        id: "t-sidequest",
        title: "Is this a good idea or another side quest?",
        body: [
            "verdict: side quest.",
            "it is always a side quest. the side quests are the point. some of them turn into portfolio websites.",
        ],
    },
    {
        id: "t-read-later",
        title: "important_read_later",
        body: [
            "saved: a long time ago. read: never.",
            "status: load-bearing tab. the browser is structurally dependent on it. do not touch.",
        ],
    },
    {
        id: "t-500",
        title: "Why is this API returning 500?",
        body: [
            "investigation status: ongoing.",
            "it's not the API. it's never the API. it's usually me. except that one time it was DNS.",
        ],
    },
    {
        id: "t-sax",
        title: "saxophone long notes",
        body: [
            "practice goal: 20 seconds of steady tone.",
            "current record: a sound the neighbours have described as 'brave'.",
        ],
    },
    {
        id: "t-mukbang",
        title: "mukbang but it's my dinner",
        body: [
            "watching someone eat 4,000 noodles while i eat dinner.",
            "we dine together in spirit. this is community.",
        ],
    },
    {
        id: "t-library",
        title: "is there a python library for this",
        body: [
            "yes. there is always a python library for this.",
            "there are three. one is deprecated. one is 40 lines long so i'll write it myself anyway. the third one is perfect and has no documentation.",
        ],
    },
    {
        id: "t-why-open",
        title: "why_is_this_tab_open.md",
        body: [
            "good question. this tab has survived three browser restarts.",
            "closing it is considered risky. relevance: unknown. loyalty: absolute.",
        ],
    },
    {
        id: "t-try-it",
        title: "what if i just tried it",
        body: [
            "dangerous thought. this tab has led to: the voice agent, the code review agent, and at least two refactorings i regret.",
            "keep it open.",
        ],
        curiosityLocked: true,
    },
    {
        id: "t-cascade",
        title: "research_cascade.txt",
        body: [
            "curiosity found this tab behind the furniture.",
            "contents: 14 open questions, 3 half-written benchmarks, 1 strong opinion about embeddings.",
        ],
        curiosityLocked: true,
    },
    {
        id: "t-one-more",
        title: "one_more_thing.exe",
        body: [
            "this tab opens other tabs. it's the reason the count is 37 and not a reasonable number.",
        ],
        curiosityLocked: true,
    },
    {
        id: "t-never-close",
        title: "the_tab_i_never_close",
        body: [
            "you found it. every developer has one — a tab that outlived its purpose and became decoration.",
            "no project link. no lesson. just a small reward for clicking the '…'. this one is yours now.",
        ],
        hidden: true,
    },
];

export const TAB_TOTAL = 37;
